import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "product-brand" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", { class: "product-brand-header" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Varemerker")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Legg til varemerke", -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "product-brand-add" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "product-brand-error"
}
const _hoisted_8 = {
  key: 0,
  class: "product-brand-list"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "product-brand-name"
}
const _hoisted_11 = {
  key: 4,
  class: "product-brand-error"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "delete-modal" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", null, "Slett varemerke", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Varemerket vil bli fjernet fra alle varer!", -1)
const _hoisted_16 = { class: "delete-modal-buttons" }

import AppLayoutVue from "@/Layouts/AppLayout.vue";
import Card from "@/Components/General/Card.vue";
import Button from "@/Components/Buttons/Button.vue";
import { mdiLoading } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import { useForm } from "@inertiajs/inertia-vue3";
import { ref } from "vue";
import Modal from "@/Components/General/Modal.vue";
import { ProductBrand } from "@/types/ProductBrand";
import Messages from "@/Components/General/Messages.vue";


export default /*#__PURE__*/_defineComponent({
  ...{
    layout: AppLayoutVue
},
  __name: 'Index',
  props: {
    brands: {}
  },
  setup(__props: any) {

const props = __props;






const form = useForm({
    name: "",
})
const editForm = useForm<{ id: number | null, name: string }>({
    id: null,
    name: "",
})
const deleteForm = useForm<{ id: number | null, name: string }>({
    id: null,
    name: "",
})


async function save() {
    form.post(route("product-brands.store"), {
        preserveScroll: true,
        onSuccess: () => {
            form.reset();
        },
        onError: () => {

        }
    });
}

function cancelEdit() {
    editForm.reset();
    editForm.clearErrors();
}

function openEdit(brand: ProductBrand) {
    editForm.id = brand.id;
    editForm.name = brand.name;
}

function openModal(brand: ProductBrand) {
    deleteForm.id = brand.id;
    deleteForm.name = brand.name;
    deleteModalIsOpen.value = true;
}

async function updateBrand() {
    if (editForm.id === null) {
        return;
    }

    editForm.put(route("product-brands.update", { brand: editForm.id }), {
        preserveScroll: true,
        onSuccess: () => {
            editForm.reset();
        }
    })
}

const deleteModalIsOpen = ref(false);

async function remove() {
    if (deleteForm.id === null) {
        return;
    }

    deleteForm.delete(route("product-brands.destroy", { brand: deleteForm.id }), {
        preserveScroll: true,
        onSuccess: () => {
            deleteForm.reset();
            deleteModalIsOpen.value = false;
        }

    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Messages),
    _hoisted_2,
    _createVNode(Card, { class: "product-brand-card" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _withModifiers(save, ["prevent"]),
          class: "product-brand-form"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "product-brand-name-input",
              class: "product-brand-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
              disabled: _unref(form).processing
            }, null, 8, _hoisted_6), [
              [_vModelText, _unref(form).name]
            ]),
            _createVNode(Button, {
              disabled: _unref(form).processing,
              color: "green",
              type: "submit",
              class: "product-brand-button"
            }, {
              default: _withCtx(() => [
                (_unref(form).processing)
                  ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                      key: 0,
                      class: "animate-spin product-brand-icon",
                      type: "mdi",
                      path: _unref(mdiLoading)
                    }, null, 8, ["path"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" Legg til ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          (_unref(form).errors.name)
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_unref(form).errors.name), 1))
            : _createCommentVNode("", true)
        ], 40, _hoisted_4)
      ]),
      _: 1
    }),
    _createVNode(Card, { class: "product-brand-card" }, {
      default: _withCtx(() => [
        (_ctx.brands.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: brand.id,
                  class: "product-brand-item"
                }, [
                  (_unref(editForm).id === brand.id)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "product-brand-input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editForm).name) = $event)),
                        disabled: _unref(editForm).processing
                      }, null, 8, _hoisted_9)), [
                        [_vModelText, _unref(editForm).name]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(brand.name), 1)),
                  (_unref(editForm).id === brand.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(Button, {
                          color: "gray",
                          class: "product-brand-button",
                          onClick: cancelEdit,
                          disabled: _unref(editForm).processing
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Avbryt ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(Button, {
                          color: "green",
                          class: "product-brand-button",
                          onClick: updateBrand,
                          disabled: _unref(editForm).processing
                        }, {
                          default: _withCtx(() => [
                            (_unref(editForm).processing)
                              ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                                  key: 0,
                                  class: "animate-spin product-brand-icon",
                                  type: "mdi",
                                  path: _unref(mdiLoading)
                                }, null, 8, ["path"]))
                              : _createCommentVNode("", true),
                            _createTextVNode(" Lagre ")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createVNode(Button, {
                          color: "gray",
                          class: "product-brand-button",
                          onClick: ($event: any) => (openEdit(brand)),
                          disabled: _unref(editForm).id !== brand.id && _unref(editForm).id !== null
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Rediger ")
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"]),
                        _createVNode(Button, {
                          color: "red",
                          class: "product-brand-button",
                          onClick: ($event: any) => (openModal(brand)),
                          disabled: _unref(editForm).id !== brand.id && _unref(editForm).id !== null
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Slett ")
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ], 64)),
                  (_unref(editForm).errors.name && _unref(editForm).id === brand.id)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_unref(editForm).errors.name), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_12, "Ingen varemerker"))
      ]),
      _: 1
    }),
    (deleteModalIsOpen.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          "with-card": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", null, [
                _createTextVNode("Er du sikker på at du vil slette \""),
                _createElementVNode("strong", null, _toDisplayString(_unref(deleteForm).name), 1),
                _createTextVNode("\"? ")
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Button, {
                  color: "gray",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteModalIsOpen.value = false)),
                  class: "product-brand-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Avbryt")
                  ]),
                  _: 1
                }),
                _createVNode(Button, {
                  color: "red",
                  onClick: remove,
                  disabled: _unref(deleteForm).processing,
                  class: "product-brand-button"
                }, {
                  default: _withCtx(() => [
                    (_unref(deleteForm).processing)
                      ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                          key: 0,
                          class: "animate-spin product-brand-icon",
                          type: "mdi",
                          path: _unref(mdiLoading)
                        }, null, 8, ["path"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Slett ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})